import { render, staticRenderFns } from "./SvgComponent.vue?vue&type=template&id=cea15e36&scoped=true"
import script from "./SvgComponent.vue?vue&type=script&lang=js"
export * from "./SvgComponent.vue?vue&type=script&lang=js"
import style0 from "./SvgComponent.vue?vue&type=style&index=0&id=cea15e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea15e36",
  null
  
)

export default component.exports